export default "__VITE_ASSET__ET1Dhzrv__"